import React from 'react'
import BookingHistory from '../../Components/User/Bookings/BookingHistory'
import UserHome from '../../Components/User/UserHome'

function BookingHistoryPage() {
  return (
    <div>
      <UserHome/>
      <BookingHistory/>
    </div>
  )
}

export default BookingHistoryPage
